/* eslint-disable no-param-reassign */

import * as types from './mutationTypes';

function extractRegionDistricts(fullDistrict, key) {
  const region = fullDistrict.find(fd => fd.region_code === key);
  return region || {};
}

export default {
  [types.START_FETCH_DISTRICTS](state) {
    state.isFetching = true;
    state.isFetched = false;
    state.error = null;
    state.regionHK = {};
    state.regionKLN = {};
    state.regionNT = {};
    state.regionETC = {};
  },

  [types.SET_FETCHED_DISTRICTS](state, districts) {
    state.isFetching = false;
    state.isFetched = true;
    state.error = null;
    state.regionHK = extractRegionDistricts(districts, 'HK');
    state.regionKLN = extractRegionDistricts(districts, 'KLN');
    state.regionNT = extractRegionDistricts(districts, 'NT');
    state.regionETC = extractRegionDistricts(districts, 'ETC');
  },

  [types.FETCH_DISTRICTS_ERROR](state, error) {
    state.isFetching = false;
    state.isFetched = false;
    state.error = error;
    state.regionHK = {};
    state.regionKLN = {};
    state.regionNT = {};
    state.regionETC = {};
  },

  [types.SET_ICS_TYPE](state, icsType) {
    state.icsType = icsType;
  },
};
